











































































































import {Component} from 'vue-property-decorator'
import Vue from 'vue';

import MainNavigation from "../components/MainNavigation.vue";
import DeleteDialog from "../components/dialogs/DeleteDialog.vue";

import Clients from "@/API/Clients";
import Client from "@/ts/interfaces/Client";
import DeleteDialogStore from "@/ts/stores/DeleteDialogStore";
import TimeUtility from '@/utils/time'
import AccountInfoDialog from "@/components/dialogs/AccountInfoDialog.vue";
import AccountInfoStore from "@/ts/stores/AccountInfoStore";
import SnackbarStore from "@/ts/stores/SnackbarStore";
import AppPackages from "@/API/AppPackages";
import Package from "@/ts/interfaces/Package";

@Component({
    components: {
        AccountInfoDialog,
        MainNavigation,
        DeleteDialog
    },
})

export default class MandatesRoot extends Vue {
    search = '';
    selected = [];

    headers = [
        {
            text: 'Nummer',
            align: 'left',
            value: 'team_id'
        },
        {
            text: 'Auftragsnummer',
            align: 'left',
            value: 'order_number'
        },
        {
            text: 'Verbrauchter Speicher (in GB)',
            align: 'left',
            value: 'space_size'
        },
        {
            text: 'Speicherlimit (in GB)',
            align: 'left',
            value: 'space_limit'
        },
        {
            text: 'Kurzbezeichnung',
            align: 'left',
            value: 'short_description'
        },
        {
            text: 'Name',
            align: 'left',
            value: 'name'
        },
        {
            text: 'Angelegte Accounts',
            align: 'left',
            value: 'user_accounts'
        },
        {
            text: 'Paketzuordnung',
            align: 'left',
            value: 'packet_id'
        },
        {
            text: 'Ust ID',
            align: 'left',
            value: 'ust_id'
        },
        {
            text: 'Erstelldatum',
            align: 'left',
            value: 'created_at'
        }
    ];
    clients: Client[] = [];
    allPackages: Package[] = [];
    selectedClient = {};

    get displayMandates() {
        return this.clients
    }

    //Lifecycle
    mounted() {
        Clients.getAllClients().then(res => {
            this.clients = res
        }).then(() => {
            AppPackages.getAppPackages().then(res => {
                this.allPackages = res
            })
        });

        //@ts-ignore:
        let mandate = document.getElementById("group-mandate").firstChild.firstChild.firstChild;
        let packages = document.getElementById("icon-packages");
        let news = document.getElementById("icon-news");
        let settings = document.getElementById("icon-settings");

        //@ts-ignore:
        mandate.style = "color: #81B219";
        //@ts-ignore:
        packages.style = "color: rgba(0, 0, 0, 0.54)";
        //@ts-ignore:
        settings.style = "color: rgba(0, 0, 0, 0.54)";
        //@ts-ignore:
        news.style = "color: rgba(0, 0, 0, 0.54)";
    }

    //Methods/Functions
    refresh() {
        Clients.getAllClients().then(res => {
            this.clients = res
        });
    }

    openDeleteDialog() {
        if (this.selected.length > 0) {
            DeleteDialogStore.show()
        }
    }

    openAccountsInfoDialog(client: Client) {
        this.selectedClient = client;
        AccountInfoStore.showAccountInfo()
    }

    onMandateSelected(client: Client) {
        this.$router.push({path: '/mandates/edit', query: {id: client.team_id.toString()}});
    }

    deleteClients() {
        for (let i = 0; i < this.selected.length; i++) {
            Clients.deleteClient(this.clients[this.clients.indexOf(this.selected[i])].team_id).then(res => {
                const index = this.clients.indexOf(this.selected[i]);
                this.clients.splice(index, 1);
            });
        }
        DeleteDialogStore.dismiss();
        SnackbarStore.showWithTimeout(
            "Mandant(en) erfolgreich gelöscht, Änderungen können erst nach einigen Minuten sichtbar werden. " +
            "Zum Aktualisieren betätigen Sie bitte den zugehörigen Button.",
            4000
        );
        this.selected = []; // don't forget to empty selected :)
    }

    getPackageName(id: number) {
        let mPackage = this.allPackages.find(function (element) {
            return element.id == id
        });

        if (mPackage) {
            return mPackage.name;
        } else {
            return id
        }
    }

    formatServerTimestamp(date: string) {
        return TimeUtility.formattedDate(date)
    }
}
